import { Component, Input, OnInit } from "@angular/core";
import { IPercentageProresss } from "../percentage-progress/percentage-progress.component";

@Component({
    selector: "count-card",
    templateUrl: "./count-card.component.html",
    styleUrls: ["./count-card.component.scss"],
    standalone: false
})
export class CountCardComponent implements OnInit {
    @Input() label: string;
    @Input() count: number | string;
    @Input() percentageProgress?: IPercentageProresss;
    @Input() tooltip: string;
    @Input() subtext = '';
    @Input() icon = '';

    tooltipPosition = 'tooltip-left';

    ngOnInit(): void {
        console.log("CountCardComponent initialized with label:", this.label);
        console.log("CountCardComponent initialized with count:", this.count);
    }

    adjustTooltip(wrapper: HTMLElement) {
        const rect = wrapper.getBoundingClientRect();
        const tooltipWidth = 150; // or get via JS if dynamic
      
        if (rect.right + tooltipWidth > window.innerWidth) {
          this.tooltipPosition = 'tooltip-left';  // shift to left side
        } else {
          this.tooltipPosition = 'tooltip-right'; // default right side
        }
      }
}

export interface ICountCard {
    label: string;
    count?: number;
    countText?: string;
    percentageProgress?: IPercentageProresss;
}